import { useAuth0 } from '@auth0/auth0-react';
import { Button, Input, Label } from '@playcastdotio/Shadcn';
import { useEffect, useState } from 'react';
import { Form, Link, useNavigate } from 'react-router-dom';
import { authStateStore, deckState2, invitationState2, joinState, playerNameState, ruleState } from '../../../api/stores';
import { saveName } from '../../../api';
import { faker } from '@faker-js/faker';
import { Invitation } from '@playcastdotio/Messaging';

export const Deck = () => {
  const { isAuthenticated, user, getAccessTokenSilently, getIdTokenClaims } = useAuth0();

  // const [selectedGameIndex, setSelectedGameIndex] = useState(0);
  const [selectedGameId, setSelectedGameId] = useState('');
  const [selectedGameInfo, setSelectedGameInfo] = useState<Invitation>();
  const [name, setName] = useState(faker.person.firstName() + ' ' + faker.person.lastName());
  const [deckGreeting, setDeckGreeting] = useState('');
  const [invitationList, setInvitationList] = useState<Invitation[]>([]);
  const [anyValid, setAnyValid] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated && ruleState.currentState.requireAuthOnDeck) {
      navigate('/sts');
    }

    setName(faker.person.firstName() + ' ' + faker.person.lastName());
    // focus the first button also
    // const buttonGrid = document.getElementById('buttonGrid');
    // if (buttonGrid) {
    //   const buttons = buttonGrid.getElementsByTagName('button');
    //   buttons[0].click();
    // }
  }, [isAuthenticated, navigate]);

  const handleJoinQueue = (selectedId: string) => {
    // event.preventDefault();
    console.log('Continue');
    // save name
    const selectedGameInfoLocal = invitationList.find((invite) => invite.id === selectedId);
    playerNameState.updateState({ name: name });
    if (name) {
      // saveName();
    }
    invitationState2.updateState({
      ...invitationState2.currentState,
      selectedInvite: selectedGameInfoLocal,
    });
    joinState.updateState({
      ...joinState.currentState,
      state: 'inQueue',
    });
  };

  useEffect(() => {
    const updateSelectedGameInfo = () => {
      const invites = Object.values(invitationState2.currentState.invites).filter((invite) => invite !== false);
      if (invites.length > 0) {
        const info = invites.find((invite) => invite.id === selectedGameId);
        if (info) {
          setSelectedGameInfo(info);
        }
      }
    };

    updateSelectedGameInfo();

    // Set up listener specifically for selection changes
    const listener = invitationState2.addListener(() => {
      updateSelectedGameInfo();
    });

    return () => {
      invitationState2.removeListener(listener);
    };
  }, [selectedGameId]);

  useEffect(() => {
    const deck = deckState2.currentState;
    if (deck) {
      setDeckGreeting(deck.greeting);
    }

    const updateInvitationData = (state = invitationState2.currentState) => {
      const invites = Object.values(state.invites)
        .filter((invite) => invite !== false)
        .filter((invite) => !invite.invalid);

      // sort alphabetically
      const alphabeticalInvites = invites.sort((a, b) => {
        const adesc = a.description || '';
        const bdesc = b.description || '';
        return adesc.localeCompare(bdesc);
      });

      setInvitationList(alphabeticalInvites);
      setAnyValid(invites.length > 0);
      console.log('Invitation list updated:', alphabeticalInvites);
    };

    // Initial load
    updateInvitationData();

    // Set up listener for state changes
    const listener = invitationState2.addListener((state) => {
      updateInvitationData(state);
    });

    return () => {
      invitationState2.removeListener(listener);
    };
  }, []);

  const handleNameChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    // setName(event.target.value);
    playerNameState.updateState({ name: event.target.value });
  };

  return (
    <section className='mt-8 flex flex-col items-center justify-center p-2 text-center text-white md:p-8'>
      <div
        className='font-[Syne] text-3xl font-medium [&>a]:text-yellow-400 [&>a]:hover:underline'
        dangerouslySetInnerHTML={{ __html: deckGreeting || '' }}
      />
      {anyValid ? (
        <Form className='flex flex-col items-center'>
          {/*<div className='row-auto mt-4 w-full lg:w-1/3'>
            <Input
              value={name}
              onChange={handleNameChanged}
              type='text'
              id='name'
              name='name'
              required
              placeholder='Name'
              className='bg-content mb-2 h-auto w-full rounded border-none px-4 py-3 text-center text-lg shadow-sm'
            />
          </div>
          */}

          <span className='py-8 text-gray-400'>Choose a Playcast to join</span>

          <div className='flex w-full flex-wrap items-center justify-center gap-y-12' id='buttonGrid'>
            {invitationList.map((invitation, index) => {
              return (
                <button key={index} className='relative mx-2 lg:mx-4' onClick={() => handleJoinQueue(invitation.id)}>
                  {/* <img src={`/images/shields/shield.png`} alt={`shield-${index}`} className='size-20 md:size-28 lg:size-48' /> */}
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    baseProfile='basic'
                    viewBox='0 0 64 64'
                    className='svg-shadow size-20 md:size-28 lg:size-48'
                  >
                    <defs>
                      <filter id='default-shadow' x='-50%' y='-50%' width='200%' height='200%'>
                        <feDropShadow dx='4' dy='4' stdDeviation='4' floodColor='#000' floodOpacity='0.5' />
                      </filter>

                      <filter id='hover-shadow' x='-50%' y='-50%' width='200%' height='200%'>
                        <feDropShadow dx='4' dy='4' stdDeviation='4' floodColor='rgba(250, 204, 21, 255)' floodOpacity='0.1' />
                      </filter>
                    </defs>
                    <path
                      fill='#a7b3c7'
                      d='M28.69,7.589l-17.028,8.173c-2.917,1.4-4.647,4.48-4.298,7.697	c1.038,9.56,5.037,20.261,20.435,30.215c2.559,1.654,5.843,1.654,8.401,0C51.599,43.72,55.597,33.02,56.636,23.459	c0.349-3.217-1.381-6.297-4.298-7.697L35.31,7.589C33.218,6.584,30.782,6.584,28.69,7.589z'
                      filter='url(#default-shadow)'
                    />
                    <path
                      fill='#ffa602'
                      d='M32,49.916c-0.527,0-1.041-0.152-1.486-0.439C19.831,42.57,13.715,35.625,12.335,22.92	c-0.12-1.1,0.479-2.165,1.491-2.65l17.028-8.173c0.361-0.173,0.747-0.261,1.146-0.261s0.786,0.088,1.146,0.261l17.028,8.174	c1.011,0.485,1.61,1.55,1.491,2.649c-1.38,12.706-7.496,19.65-18.179,26.556C33.041,49.764,32.527,49.916,32,49.916z'
                      filter='url(#default-shadow)'
                    />
                    <path
                      d='M33.486,49.476c10.683-6.906,16.799-13.85,18.179-26.556c0.12-1.1-0.479-2.164-1.491-2.649	l-17.028-8.174c-0.36-0.173-0.746-0.261-1.146-0.261v38.08C32.527,49.916,33.041,49.764,33.486,49.476z'
                      opacity='.2'
                      filter='url(#default-shadow)'
                    />
                    <line
                      x1='17.434'
                      x2='26.609'
                      y1='18.538'
                      y2='14.134'
                      fill='none'
                      stroke='#fff'
                      strokeLinecap='round'
                      strokeMiterlimit='10'
                      strokeWidth='3'
                    />
                    <path
                      fill='#fff'
                      d='M33.636,7.015c-1.651-0.362-3.393-0.172-4.946,0.573l-17.028,8.173	c-2.917,1.4-4.647,4.48-4.298,7.697c0.168,1.543,0.414,3.196,0.772,4.922c2.621-0.411,4.489-2.797,4.199-5.462	c-0.12-1.1,0.479-2.164,1.491-2.649l17.028-8.173C32.828,11.149,33.874,9.075,33.636,7.015z'
                      opacity='.3'
                      filter='url(#default-shadow)'
                    />
                    <path
                      d='M56.636,23.459c0.349-3.217-1.381-6.297-4.298-7.697l-4.508-2.164c0,0,0,0,0,0	c-1.195,2.489-0.146,5.476,2.344,6.671c1.011,0.485,1.61,1.55,1.491,2.65c-1.38,12.706-7.496,19.65-18.179,26.556	c-1.84,1.19-2.617,3.381-2.119,5.395c1.668,0.137,3.369-0.249,4.834-1.196C51.599,43.72,55.597,33.02,56.636,23.459z'
                      opacity='.15'
                      filter='url(#default-shadow)'
                    />
                    <ellipse cx='32' cy='60' opacity='.3' rx='13' ry='3' />
                  </svg>
                  <span
                    className='text-md absolute bottom-0 left-1/2 w-full -translate-x-1/2 transform font-bold text-white md:text-xl'
                    style={{
                      textShadow: '2px 2px 0 #000, -2px 2px 0 #000, 2px -2px 0 #000, -2px -2px 0 #000',
                    }}
                  >
                    {invitation.description || ''}
                  </span>
                  <span
                    className='md:text-md absolute -bottom-5 left-1/2 w-full -translate-x-1/2 transform text-sm font-bold text-white'
                    style={{
                      textShadow: '2px 2px 0 #000, -2px 2px 0 #000, 2px -2px 0 #000, -2px -2px 0 #000',
                    }}
                  >
                    {''}
                  </span>
                  {/* {selectedGameIndex === index && (
                    <span
                      className='text-primary text-xl font-bold absolute right-0 w-fit top-0 rotate-[8deg] lg:right-5 lg:top-5 lg:text-2xl'
                      style={{
                        textShadow: '2px 2px 0 #000, -2px 2px 0 #000, 2px -2px 0 #000, -2px -2px 0 #000',
                      }}
                    >
                      Yeah!
                    </span>
                  )} */}
                </button>
              );
            })}
          </div>

          {/* <h1 className='mt-8 font-[Syne] text-2xl font-medium'>{selectedGameInfo?.description}</h1> */}

          {/* <div className='mt-14 py-2 text-sm'>
            <div>
              There are {selectedGameInfo?.pendingCount === -1 ? '' : selectedGameInfo?.pendingCount} people currently in this queue
            </div>
          </div> */}
        </Form>
      ) : (
        <div className='mt-8 flex w-full justify-center'>
          <div className='w-full space-y-4 rounded-lg bg-gray-700 p-4 py-6 text-center shadow-md md:w-2/3 lg:w-2/5'>
            <h3 className='row-auto text-xl font-bold'>This page is not currently active</h3>
            <p className='row-auto'>
              The playcaster may not have started any broadcasts yet. Please check back later or contact the playcaster for more
              information.
            </p>
          </div>
        </div>
      )}
    </section>
  );
};
